class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');

    // 開け閉めはここで行い、毎回ヘッダーから下へ広がる・上へたたむ動きを付ける。
    // CSS のアニメーションだと、閉じた details の中は再計算されないため2回目から動かない
    this.summary.addEventListener('click', (event) => {
      event.preventDefault();
      if (this.mainDetailsToggle.open && !this.mainDetailsToggle.classList.contains('is-closing')) {
        this.close();
      } else {
        this.open();
      }
    });

    // メニューの外（下のページを覆う紺の幕を含む）を押したら閉じる。
    // 別のメニューを押したときは、2つのメニューが重ならないよう動きを付けずにすぐ閉じる
    document.addEventListener('click', (event) => {
      if (!this.mainDetailsToggle.open || this.contains(event.target)) return;
      this.close(!event.target.closest('header-menu'));
    });
  }

  get reduceMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  stopMotion() {
    (this.motion || []).forEach((animation) => animation.cancel());
    this.motion = [];
  }

  open() {
    this.stopMotion();
    this.mainDetailsToggle.classList.remove('is-closing');
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
    if (this.reduceMotion) return;

    const inner = this.content.firstElementChild;
    this.motion = [
      this.content.animate([{ clipPath: 'inset(0 0 100% 0)' }, { clipPath: 'inset(0 0 0 0)' }], {
        duration: 420,
        easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
      }),
    ];
    if (inner) {
      this.motion.push(
        inner.animate(
          [
            { opacity: 0, transform: 'translateY(-8px)' },
            { opacity: 1, transform: 'translateY(0)' },
          ],
          { duration: 360, delay: 80, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'backwards' }
        )
      );
    }
  }

  close(animate = true) {
    const details = this.mainDetailsToggle;
    if (!details.open) return;
    this.stopMotion();
    this.summary.setAttribute('aria-expanded', false);

    const finish = () => {
      this.stopMotion();
      details.classList.remove('is-closing');
      details.removeAttribute('open');
    };
    if (!animate || this.reduceMotion) {
      finish();
      return;
    }

    details.classList.add('is-closing');
    const fold = this.content.animate([{ clipPath: 'inset(0 0 0 0)' }, { clipPath: 'inset(0 0 100% 0)' }], {
      duration: 260,
      easing: 'cubic-bezier(0.4, 0, 1, 1)',
      fill: 'forwards',
    });
    this.motion = [fold];
    fold.onfinish = finish;
  }

  // キーボードでメニューの外へ移ったときはすぐ閉じる。クリックで外へ出たときは上の click で閉じる
  onFocusOut() {
    setTimeout(() => {
      const active = document.activeElement;
      if (this.contains(active) || active === document.body) return;
      this.close(false);
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
